import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("rb_user");
    return raw ? JSON.parse(raw) : null;
  });

  const persist = useCallback((u) => {
    localStorage.setItem("rb_user", JSON.stringify(u));
    setUser(u);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rb_token", data.token);
    persist(data.user);
    return data.user;
  }, [persist]);

  const refreshUser = useCallback(async () => {
    if (!localStorage.getItem("rb_token")) return;
    try {
      const { data } = await api.get("/auth/me");
      persist({ nome: data.nome, email: data.email, ruolo: data.ruolo, permessi: data.permessi || {} });
    } catch (err) {
      if (err?.response?.status === 401) {
        // Token scaduto/non valido: pulizia sessione
        localStorage.removeItem("rb_token");
        localStorage.removeItem("rb_user");
        setUser(null);
      } else {
        console.error("Errore aggiornamento sessione:", err);
      }
    }
  }, [persist]);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const logout = useCallback(() => {
    localStorage.removeItem("rb_token");
    localStorage.removeItem("rb_user");
    setUser(null);
  }, []);

  const can = useCallback((perm) => !!(user && user.permessi && user.permessi[perm]), [user]);

  const value = useMemo(() => ({ user, login, logout, refreshUser, can }), [user, login, logout, refreshUser, can]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
